'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isModifier = exports.isModifier = function isModifier(key) {
  return key[0] === '&';
};
var isElement = exports.isElement = function isElement(key) {
  return !isModifier(key);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/substyle/lib/filterKeys.js
// module id = 355
// module chunks = 0 15 16 17 18